<template>
 <div class="height">
   <el-tabs v-model="TabsValue" type="card" closable @tab-remove="removeTab">
     <el-tab-pane v-for="(item, index) in editableTabs2" :key="item.name" :label="item.title" :name="item.name">
       <tab-component :index="index" :name="index"></tab-component>
     </el-tab-pane>
   </el-tabs>
 </div>
</template>
<style>
  .el-tabs{
    height: calc(100% - 60px);
  }
  .height{
    height: 100%
  }
  .el-tabs__content{
    flex-grow: 1;
    /*overflow-y: scroll;*/
    overflow-y:  scroll !important;
    height: 100%;
  }
</style>
<script>
  import trans from '../../transform/trans'
  export default {
    data() {
      return {
        uniqueOpened: true,
        TabsValue: '',
        editableTabsValue2: '0',
        editableTabs2: [],
        tabIndex: 0
      }
    },
    created(){
      this.clientHeight = `${document.documentElement.clientHeight}`;
      var self=this;
      trans.$on('select-slider', function(data){
        self.addTab2(data);
    });
    },
    methods: {
      addTab2(menu, index) {
        let exist = false;
        for (var i = 0; i < this.editableTabs2.length; i++) {
          if (menu.name === this.editableTabs2[i].name) {
            exist = true;
            break
          }
        }
        if (exist === true) {
          this.TabsValue = menu.name;
          return
        }
        this.editableTabs2.push({
          title: menu.name,
          name: menu.name,
          content: menu.component
        });
        var _this = this;
        this.$Vue.component('tab-component', {
          render: function (h) {
            var comp = _this.editableTabs2[this.index].content;
            return h(comp)
          },
          props: {
            index: {
              type: Number,
              required: true
            }
          }
        });
        this.TabsValue = menu.name;
      },
      removeTab(targetName) {
        let tabs = this.editableTabs2;
        let activeName = this.editableTabsValue2;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
        }

        this.editableTabsValue2 = activeName;
        this.editableTabs2 = tabs.filter(tab => tab.name !== targetName);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/commerical/CommericalMain.vue